import { h } from 'preact'
import { closeWidget } from '../../shared/utils'
import globalVars from '../../shared/global'
import * as style from './style.css'

const CustomRedirectHeader: preact.FunctionalComponent = () => {
    return (
        <header class={style.header}>
            {globalVars.isMounted && <div class={style.headerClose} onClick={closeWidget} />}
        </header>
    )
}

export default CustomRedirectHeader
